import { useEffect, useSyncExternalStore } from 'react';
import { Platform } from 'react-native';
import { usePathname, useRootNavigationState, useRouter, useSegments } from 'expo-router';
import { useAuthStore } from '@/store/auth';
import { nativeLinkInbox } from '@/lib/nativeLinkInbox';

export default function useNativeLinkInbox() {
  const pending = useSyncExternalStore(nativeLinkInbox.subscribe, nativeLinkInbox.snapshot, nativeLinkInbox.snapshot);
  const userId = useAuthStore(state => state.user?.id);
  const token = useAuthStore(state => state.token);
  const navigation = useRootNavigationState();
  const segments = useSegments();
  const pathname = usePathname();
  const router = useRouter();
  useEffect(() => {
    if (!['ios', 'android'].includes(Platform.OS) || !pending || !navigation?.key || !token || !userId
      || segments[0] !== '(app)') return;
    const destination = nativeLinkInbox.take();
    // Warm native links are already routed by Expo. Replaying a launch route
    // can race its own redirect to the composer and leave an empty screen.
    if (destination && destination !== pathname) router.replace(destination);
  }, [pending, navigation?.key, token, userId, segments, pathname, router]);
}
